import Immutable from 'seamless-immutable';
import _ from 'lodash';
import ExportTaskModel from './export-task-model';

function create(entries = []) {
  return Immutable(_.map(entries, ExportTaskModel.create));
}

function deserialize(entries = []) {
  return Immutable(_.map(entries, ExportTaskModel.deserialize));
}

export default {
  create,
  deserialize,
};
